import { render, staticRenderFns } from "./globalModifier.vue?vue&type=template&id=40f1e672&scoped=true"
import script from "./globalModifier.vue?vue&type=script&lang=js"
export * from "./globalModifier.vue?vue&type=script&lang=js"
import style0 from "./globalModifier.vue?vue&type=style&index=0&id=40f1e672&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f1e672",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2585860866/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40f1e672')) {
      api.createRecord('40f1e672', component.options)
    } else {
      api.reload('40f1e672', component.options)
    }
    module.hot.accept("./globalModifier.vue?vue&type=template&id=40f1e672&scoped=true", function () {
      api.rerender('40f1e672', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/menu/globalMods/globalModGroupConfig/globalModifier.vue"
export default component.exports